export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5485.dd612ca7.jpg";